import { render, staticRenderFns } from "./SmsWinners.vue?vue&type=template&id=38345659&"
import script from "./SmsWinners.vue?vue&type=script&lang=js&"
export * from "./SmsWinners.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports